/**
 * Trava o scroll do documento enquanto houver um painel em tela cheia
 * (modal, drawer, overlay). Vale para o portal inteiro.
 * O miolo do painel, se tiver rolagem própria, continua rolando.
 */

const LOCK_CLASS = 'portal-scroll-lock'

function classLooksLikeOverlay(el) {
  const name = el.className
  if (typeof name !== 'string' || !name) return false
  return /(^|\s)[\w-]*overlay(\s|$)/i.test(name)
}

function isVisible(el) {
  const style = window.getComputedStyle(el)
  if (style.display === 'none' || style.visibility === 'hidden') return false
  if (style.pointerEvents === 'none') return false
  if (Number(style.opacity) === 0) return false
  return true
}

function coversViewport(el) {
  const rect = el.getBoundingClientRect()
  if (rect.width < window.innerWidth * 0.85) return false
  if (rect.height < window.innerHeight * 0.85) return false
  return true
}

export function isBlockingOverlay(el) {
  if (!(el instanceof Element)) return false
  if (!classLooksLikeOverlay(el)) return false
  if (!isVisible(el)) return false
  const style = window.getComputedStyle(el)
  if (style.position !== 'fixed' && style.position !== 'absolute') return false
  return coversViewport(el)
}

function findBlockingOverlay(node) {
  let el = node instanceof Element ? node : node?.parentElement
  while (el && el !== document.documentElement) {
    if (isBlockingOverlay(el)) return el
    el = el.parentElement
  }
  return null
}

function findScrollableWithin(node, boundary) {
  let el = node instanceof Element ? node : node?.parentElement
  while (el && el !== boundary) {
    const style = window.getComputedStyle(el)
    const overflowY = style.overflowY
    if (
      (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') &&
      el.scrollHeight > el.clientHeight + 1
    ) {
      return el
    }
    el = el.parentElement
  }
  return null
}

function wheelWouldEscape(scroller, deltaY) {
  if (!scroller || scroller.scrollHeight <= scroller.clientHeight + 1) return true
  if (deltaY < 0 && scroller.scrollTop <= 0) return true
  const max = scroller.scrollHeight - scroller.clientHeight
  if (deltaY > 0 && scroller.scrollTop >= max - 1) return true
  return false
}

function onWheel(event) {
  const overlay = findBlockingOverlay(event.target)
  if (!overlay) return
  const scroller = findScrollableWithin(event.target, overlay)
  if (wheelWouldEscape(scroller, event.deltaY)) {
    event.preventDefault()
  }
}

function syncLock() {
  const nodes = document.querySelectorAll('[class*="overlay"]')
  let locked = false
  for (const el of nodes) {
    if (isBlockingOverlay(el)) {
      locked = true
      break
    }
  }
  document.documentElement.classList.toggle(LOCK_CLASS, locked)
}

let scheduled = false
function scheduleSync() {
  if (scheduled) return
  scheduled = true
  requestAnimationFrame(() => {
    scheduled = false
    syncLock()
  })
}

export function installBackgroundScrollLock() {
  if (typeof document === 'undefined' || document.documentElement.dataset.portalScrollLock) {
    return
  }
  document.documentElement.dataset.portalScrollLock = '1'

  const observer = new MutationObserver(scheduleSync)
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden'],
  })

  window.addEventListener('resize', scheduleSync)
  document.addEventListener('wheel', onWheel, { capture: true, passive: false })
  document.addEventListener(
    'touchmove',
    event => {
      const overlay = findBlockingOverlay(event.target)
      if (!overlay) return
      const scroller = findScrollableWithin(event.target, overlay)
      if (!scroller) event.preventDefault()
    },
    { capture: true, passive: false }
  )

  scheduleSync()
}
